export const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
export const frontendUrl = process.env.REACT_APP_FRONTEND_URL;
export const livestreamUrl = process.env.REACT_APP_LIVESTREAM_URL;
export const accessToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN
export const googleKey = process.env.REACT_APP_FIREBASE_API_KEY;  
 